import { useNavigate, useLocation } from 'react-router-dom';
import '../common/Mypage.scss';
import MypageMenu from '../common/MypageMenu';
import PostingManagePanel from './posting/PostingManagePanel';
import ResumeManagePanel from './resume/ResumeManagePanel';
import ApplicationManagePanel from './resume/ApplicationManagePanel';
import JobAlertsPanel from '../alerts/JobAlertsPanel';

type SectionType = 'posting' | 'resume';
type TabType = 'resume' | 'application';

const RESUME_TABS: { id: TabType; label: string; path: string }[] = [
  { id: 'resume', label: '이력서 관리', path: '/mypage/resumemanage' },
  { id: 'application', label: '지원현황', path: '/mypage/applications' },
];

const SECTION_COPY: Record<SectionType, { title: string; copy: string }> = {
  posting: {
    title: '구인게시글 관리',
    copy: '등록한 구인 공고글을 확인하고 수정·삭제하거나 지원자를 관리할 수 있습니다.',
  },
  resume: {
    title: '이력서 관리',
    copy: '등록한 이력서와 지원 내역, 공고 알림 조건을 확인하고 관리할 수 있습니다.',
  },
};

export default function RecruitManage({ section }: { section: SectionType }) {
  const navigate = useNavigate();
  const location = useLocation();
  const activeTab: TabType = location.pathname.startsWith('/mypage/applications') || location.pathname.startsWith('/mypage/applicationmanage')
    ? 'application'
    : 'resume';
  const { title, copy } = SECTION_COPY[section];

  return (
    <div className='mypage'>
      <div className="inner">
        <MypageMenu />
        <div className="subpage__main">
          <div className="mypage-panel mypage-section-card">
            <div className="mypage-section-head">
              <div>
                <h2 className="mypage-section-title">{title}</h2>
                <p className="mypage-section-copy">{copy}</p>
              </div>
              {section === 'resume' && (
                <div className="mypage-filter-row">
                  {RESUME_TABS.map((tab) => (
                    <button
                      key={tab.id}
                      type="button"
                      className={`mypage-filter-chip ${activeTab === tab.id ? 'is-active' : ''}`}
                      onClick={() => {
                        navigate(tab.path);
                        window.scrollTo(0, 0);
                      }}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>
              )}
            </div>

            {section === 'posting' ? (
              <PostingManagePanel />
            ) : activeTab === 'resume' ? (
              <>
                <ResumeManagePanel />
                <JobAlertsPanel />
              </>
            ) : (
              <ApplicationManagePanel />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
